import React from 'react';
import { Row, Col } from 'antd';
import { Link, useLocation } from 'react-router-dom';
// import carImage from "../../assets/images/vehicles/Hyundai_Tucson_View1_Fix.png";
// import { getSubscription } from '../../api';

const SubscriptionSuccessful = () => {
    const location = useLocation();
    const {
        state: { data },
    } = location;
    return (
        <div className="subscriptionSuccessfulContainer">
            <Row justify="center">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="subscriptionSuccessfulHero"
                >
                    <h2>Subscription Successful!</h2>
                    <p>Thank you for choosing Yoma Fleet Easy Lease. We are currently processing your application.</p>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="subscriptionSuccessfulInfo"
                >
                    <h4>{`${data?.vehicle?.year} ${data?.vehicle?.name}`}</h4>
                    <p>
                        <span className="subscriptionSuccessfulInfoLabel">Booking Duration :</span>
                        {data.period_of_hire} months
                    </p>
                    <p>
                        <span className="subscriptionSuccessfulInfoLabel">Kilometer per month :</span>
                        {data.km_per_month} km
                    </p>
                    <p>
                        <span className="subscriptionSuccessfulInfoLabel">Total price :</span>
                        {data.currency}
                        {data.total_price_with_tax}
                    </p>
                    <p>
                        <span className="subscriptionSuccessfulInfoLabel">Price per month :</span>
                        {data.currency}
                        {data.monthly_rate_with_tax}
                    </p>

                    <Link
                        className="viewSubscription"
                        to={{
                            pathname: '/subscriptions',
                            search: `ref=${data.confirmation_number}`,
                        }}
                    >
                        View Subscritpion
                    </Link>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="subscriptionSuccessfulImage"
                >
                    <img src={data?.vehicle?.feature_photo} alt="Car" />
                </Col>
            </Row>
        </div>
    );
};

export default SubscriptionSuccessful;
